import { actionCreators as documentDetailsActionCreators } from "Areas/Documents/documentDetails";
import { actionCreators as documentEditorActionCreators, modeEnum } from "Areas/Documents/documentEditorPanel";
import documentsActionCreators from "Areas/Documents/redux/actionCreators";
import documentRoutingKeys from "Areas/Documents/routingKeys";
import { Permissions, security } from "Common/permissions";
import { routesAndPagesMap } from "Common/routingUtils";
import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getActiveDocumentId, getDocuments, getDocumentsInProgress, getProjectId, getSelectedDocumentIds } from "../redux/selectors";
import TabDocuments from "./tabDocuments";
const canOpen = (_, projectId) => Boolean(routesAndPagesMap.getPath(documentRoutingKeys.DOCUMENTS, projectId));
const canEditDocuments = security.isAllowed([Permissions.DocumentsEdit]);
const canDeleteDocuments = security.isAllowed([Permissions.DocumentsDelete]);
const mapStateToProps = (state) => ({
    projectId: getProjectId(state),
    inProgress: getDocumentsInProgress(state),
    documents: getDocuments(state),
    selectedDocumentIds: getSelectedDocumentIds(state),
    activeDocumentId: getActiveDocumentId(state),
    canEditDocuments,
    canOpen,
    canDeleteDocuments
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (projectId) => dispatch(actionCreators.getDocuments(projectId)),
    onOpenDocumentEditorPanel: (documentId, mode) => dispatch(mode === modeEnum.EDIT
        ? documentEditorActionCreators.setEditDocument(documentId)
        : documentEditorActionCreators.setDuplicateDocument(documentId)),
    onOpenDocumentCreatorPanel: (projectId) => dispatch(documentEditorActionCreators.setCreateNewDocument(projectId)),
    onDeleteDocument: (projectId, documentId) => dispatch(documentsActionCreators.deleteDocument(documentId, projectId)),
    onSetDocumentSelected: (documentId, selected, readOnlyMode) => {
        dispatch(actionCreators.setDocumentSelected(documentId, selected));
        readOnlyMode !== undefined &&
            dispatch(documentDetailsActionCreators.setReadOnlyMode(documentId, readOnlyMode));
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(TabDocuments);
